import { useEffect, useState } from 'react';
import PublicAPI from '@/api/TreedisPublicDAO';
import { GameLock, LockType } from '@/_models/Game';

export const useLockPath = (gameId: number) => {
  const [lockPath, setLockPath] = useState<GameLock | undefined>();

  useEffect(() => {
    const fetchPath = async () => {
      const res = await PublicAPI.getLockByType({ type: LockType.Path, gameId });
      if (res.lock) {
        setLockPath(new GameLock(res.lock));
      }
    };

    fetchPath();
  }, [gameId]);

  return { lockPath };
};
